var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"multi-component"},[_c('ctint-contact-history-detail',{attrs:{"params":_vm.params_contacthistory,"namespace":_vm.namespace_contacthistory},on:{"showConversationDetail":_vm.showConversationDetail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }